import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, type HttpEvent, type HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TOKEN_KEY } from "@environments/environment";
import { ApiService } from "@app/services/api.service";
import { AuthService } from "@app/services/auth.service";


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private apiService: ApiService, private authService: AuthService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const jwt_token = localStorage.getItem(TOKEN_KEY)

    const jwtTokenPresent = !!jwt_token;

    if (jwtTokenPresent) {
      const payload                      = this.apiService.extractPayload(jwt_token);
      const { user, valid_until, scope } = payload

      if (scope.find((e) => e === 'backend') && parseInt(valid_until) > Math.round(new Date().getTime() / 1000)) {

        this.authService.scope = scope

        request = request.clone({
          setHeaders:      {
            'X-Authorization-Token': `${ jwt_token }`,
            //'X-Skip-Request-Tracking': 'true' // uncomment this in dev if you are facing too many requests error
          },
          withCredentials: false,
        });

      } else {
        this.authService.scope = []
      }
    }

    return next.handle(request);
  }

}
